import { lazy } from 'react';
import { retry } from '../../config/utils';

const Login = lazy(() =>  retry(() =>import(/* webpackChunkName: "login" */ "./index")));

export default Login;